import { Image as ImageIcon, ExternalLink } from 'lucide-react';
import { GRAD, fg, fgMuted, surface, border, muted, type SharedImage } from './profile-shared';

interface MediaTabProps {
  convId: string | null;
  images: SharedImage[];
  mediaLoading: boolean;
  onOpenLightbox: (url: string) => void;
}

export default function MediaTab({ convId, images, mediaLoading, onOpenLightbox }: MediaTabProps) {
  return (
    <div className="rounded-2xl p-5" style={{ background: surface, border: `1px solid ${border}` }}>
      <div className="mb-4 flex items-center gap-2">
        <ImageIcon size={16} style={{ color: GRAD }} />
        <h2 className="text-sm font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: fg }}>
          Shared Photos
        </h2>
      </div>

      {mediaLoading ? (
        <div className="flex items-center justify-center py-12">
          <div className="h-6 w-6 animate-spin rounded-full border-b-2" style={{ borderColor: GRAD }} />
        </div>
      ) : !convId ? (
        <p className="py-8 text-center text-sm" style={{ color: fgMuted, fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
          No active conversation yet.
        </p>
      ) : images.length === 0 ? (
        <div className="flex flex-col items-center gap-3 py-12 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl"
            style={{ background: 'hsla(243,75%,59%,0.1)' }}>
            <ImageIcon size={24} style={{ color: GRAD }} />
          </div>
          <p className="text-sm font-semibold" style={{ color: fg, fontFamily: 'Outfit, sans-serif' }}>No photos shared yet</p>
          <p className="max-w-xs text-xs" style={{ color: fgMuted, fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
            Photos shared in your chat conversation will appear here.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-3 gap-2 sm:grid-cols-4 md:grid-cols-5">
          {images.map(img => (
            <button
              key={img.id}
              onClick={() => onOpenLightbox(img.attachmentUrl!)}
              className="group relative aspect-square overflow-hidden rounded-xl transition-all hover:opacity-90 hover:scale-[1.02]"
              style={{ background: muted }}>
              <img
                src={img.attachmentUrl!}
                alt={img.attachmentName ?? 'Shared photo'}
                className="h-full w-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity group-hover:opacity-100"
                style={{ background: 'rgba(0,0,0,0.3)' }}>
                <ExternalLink size={16} style={{ color: '#fff' }} />
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
